import Page from './index.vue';

export default { path: '/home/operationLog', component: Page };
